import type { useGetCareEvent } from "api/hooks/useGetCareEvent";
import type { CareEventBilling } from "api/schemas/CareEventBilling";
import { DynamicMedicalNoteForm } from "routes/patients/PatientProfile/components/PatientHeader/SignNotesTable/components/DynamicMedicalNoteForm";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";

type CareEventData = NonNullable<ReturnType<typeof useGetCareEvent>["data"]>;

interface Props {
  careEvent: CareEventData;
  selectedCareEvent: CareEventBilling | null;
  onClose: () => void;
}

export function CareEventDialog({ careEvent, selectedCareEvent, onClose }: Props) {
  return (
    <MUIUnifiedModal open onClose={onClose} width="770px">
      <DynamicMedicalNoteForm
        careEvent={{
          ...careEvent,
          medical_referral_id: selectedCareEvent?.medical_referral_id,
          plan_of_care_id: selectedCareEvent?.plan_of_care_id,
        }}
        open
        isAdminBillingView
        billingStatus={selectedCareEvent?.status}
        skipMerge
        showNoteHeader
        readOnly
        clearSelectedCareEvent={onClose}
      />
    </MUIUnifiedModal>
  );
}
